import { FC } from 'react';
import Typography from '@ui/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Fab from '@material-ui/core/Fab';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import {
    recapImageStyle,
    recapItemLabelStyle,
    nestedListItemLegendFormFieldRecapStyle,
    recapAvatarStyle,
    recapItemListItemStyle,
    recapItemListItemTextStyle,
    pdfLinkStyle,
    pdfFabStyle,
    imageWrapperStyle,
} from './styles';
import {
    IFormFieldRecapItemProperties,
} from './types';

const FormFieldRecapItem: FC<IFormFieldRecapItemProperties> = ({
    label,
    value,
    image,
    thumbnail,
    link,
}) => (
    <>
        <ListItem disableGutters dense style={recapItemListItemStyle}>
            {thumbnail && (
                <ListItemAvatar>
                    <Avatar style={recapAvatarStyle} alt="shape pattern" src={thumbnail} />
                </ListItemAvatar>
            )}

            <ListItemText
                style={recapItemListItemTextStyle}
                {...(label && {
                    primary: (
                        <Typography variant="caption" style={recapItemLabelStyle}>
                            <small>{label}</small>
                        </Typography>
                    ),
                })}
                {...(value && {
                    secondary: (
                        <Typography variant="body2" style={nestedListItemLegendFormFieldRecapStyle}>
                            {link ? <a style={{ color: 'inherit', textDecoration: 'underline' }} href={link}>{value}</a> : value}
                        </Typography>
                    ),
                })}
            />
        </ListItem>

        {image && Array.isArray(image) && image.map((img) => (
            <div style={imageWrapperStyle} key={img}>
                <embed style={recapImageStyle} src={img} title="inspiration" />

                {img.includes('.pdf?') && (
                    <Fab color="secondary" aria-label="edit" style={pdfFabStyle} size="small">
                        <a href={img} target="_blank" rel="noreferrer noopener" title="open" style={pdfLinkStyle}>
                            <OpenInNewIcon />
                        </a>
                    </Fab>
                )}
            </div>
        ))}

        {image && typeof image === 'string' && (
            <div style={imageWrapperStyle}>
                <embed style={recapImageStyle} src={image} title="inspiration" />

                {image.includes('.pdf?') && (
                    <Fab color="secondary" aria-label="edit" style={pdfFabStyle} size="small">
                        <a href={image} target="_blank" rel="noreferrer noopener" title="open" style={pdfLinkStyle}>
                            <OpenInNewIcon />
                        </a>
                    </Fab>
                )}
            </div>
        )}
    </>
);

export default FormFieldRecapItem;
